// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Details } from '@return-rabbit/nexus';
import get from 'lodash.get';

import { FlexColumn, Gap } from 'ui-components/components/flex';

import { ReturnDetails } from '../components/return-details';
import { ReturnPayment } from '../components/return-payment';
import { CustomerAddress } from '../components/customer-address';
import { CostSummary } from '../components/cost-summary';
import { RmaInfo } from '../components/rma-info';
import { LineItems } from '../components/line-items';
import { ExchangeItem } from '../components/exchange-item';
import { useFulfillmentPlannerContext } from '../../../../fulfillment-planner/context';

import style from './styles.module.less';

export function PendingReturnInfo() {
  const { totalCost } = useFulfillmentPlannerContext();
  const { createdReturnMode } = Details.useReturnMode();
  const { returnItems, purchaseItems } = Details.useLineItems();
  const { isSavingShippingCost } = Details.useShippingInfo();
  const { currency, returnCost, purchaseCost, shippingFee, paymentProcessingFee, returnProcessingFee, giftCardIncentive, totalAmount } =
    Details.usePaymentInfo();

  const carrierFee = isSavingShippingCost ? undefined : get(totalCost, 'value');

  return (
    <>
      <ReturnDetails
        address={<CustomerAddress isEditable />}
        costSummary={
          <CostSummary
            allowColorCode
            carrierFee={carrierFee}
            currencyCode={currency}
            giftCardIncentive={giftCardIncentive}
            mode={createdReturnMode}
            paymentProcessingFee={paymentProcessingFee}
            purchaseCost={purchaseCost}
            returnCost={returnCost}
            returnProcessingFee={returnProcessingFee}
            shippingFee={shippingFee}
            totalAmount={totalAmount}
          />
        }
        rmaInfo={<RmaInfo />}
      />
      <ReturnPayment />
      <LineItems
        itemDataGenerator={(item) => ({
          name: get(item, 'orderedVariant.title', ''),
          sku: get(item, 'orderedVariant.sku', ''),
          imageURL: get(item, 'orderedVariant.imageUrl', ''),
          quantity: get(item, 'quantity', 0),
          totalPrice: get(item, 'amount', 0),
          currency: get(item, 'currency', ''),
          returnReason: get(item, 'requestReason', ''),
        })}
        items={returnItems}
        renderItemSubRow={(item) => {
          const data = get(item, 'exchangeVariant', null);
          return (
            <FlexColumn className={style['item-content']} gap={Gap.Space16}>
              <ExchangeItem data={data} />
            </FlexColumn>
          );
        }}
      />
      <LineItems
        itemDataGenerator={(item) => ({
          name: get(item, 'purchaseVariant.title', ''),
          sku: get(item, 'purchaseVariant.sku', ''),
          imageURL: get(item, 'purchaseVariant.imageUrl', ''),
          quantity: get(item, 'quantity', 0),
          totalPrice: get(item, 'amount', 0),
          currency: get(item, 'currency', ''),
          returnReason: get(item, 'requestReason', ''),
        })}
        items={purchaseItems}
        type='Purchase'
      />
    </>
  );
}
